(function () {
  'use strict';

  function initCarousel(el) {
    if (typeof EmblaCarousel === 'undefined') return;

    var viewport = el.querySelector('.bss-embla__viewport');
    if (!viewport) return;

    var productCount = parseInt(el.dataset.productCount, 10) || 0;
    var desktopCols = parseInt(el.dataset.desktopCols, 10) || 3;

    /* Restore the original options that were confirmed working, then add
       infinite-loop behaviour on top via the same loop:true setting. */
    var embla = EmblaCarousel(viewport, {
      loop: true,
      align: 'center',
      slidesToScroll: 1,
      breakpoints: {
        '(min-width: 768px)': {
          align: 'start',
          containScroll: 'trimSnaps',
        }
      }
    });

    embla.on('reInit', function () {
      requestAnimationFrame(function () {
        embla.scrollTo(0, false);
      });
    });

    var prevBtn = el.querySelector('.bss-prev');
    var nextBtn = el.querySelector('.bss-next');

    if (nextBtn) nextBtn.addEventListener('click', function () { embla.scrollNext(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { embla.scrollPrev(); });

    /* Hide arrows on desktop when the collection fits exactly (nothing to scroll past).
       Must use style.display — author CSS display:flex overrides the UA [hidden] rule. */
    function syncArrows() {
      var isDesktop = window.innerWidth >= 768;
      var hide = isDesktop && productCount <= desktopCols;
      if (prevBtn) prevBtn.style.display = hide ? 'none' : '';
      if (nextBtn) nextBtn.style.display = hide ? 'none' : '';
    }

    embla.on('reInit', syncArrows);
    syncArrows();

    var dotsContainer = el.querySelector('.bss-dots');
    if (dotsContainer) initDots(embla, dotsContainer);
  }

  function initDots(embla, container) {
    var dots = [];

    function buildDots() {
      container.innerHTML = '';
      dots = embla.slideNodes().map(function (_, i) {
        var btn = document.createElement('button');
        btn.className = 'bss-dot';
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        btn.addEventListener('click', function () { embla.scrollTo(i); });
        container.appendChild(btn);
        return btn;
      });
      syncDots();
    }

    function syncDots() {
      var selected = embla.selectedScrollSnap();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-selected', i === selected);
      });
    }

    embla.on('select', syncDots);
    embla.on('reInit', buildDots);
    buildDots();
  }

  document.querySelectorAll('.bss-carousel').forEach(initCarousel);
})();
